import { ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useSite } from "@/hooks/use-site";
import { localizeUrl } from "@/lib/site";

export function CtaBand() {
  const { messages, site, href } = useSite();
  const contactSales = localizeUrl("/contacts?inquiry=sales#inquiry-form", site.locale, href);
  const bookDemo = localizeUrl("/contacts?inquiry=demo#inquiry-form", site.locale, href);
  return (
    <section
      id="contact"
      className="relative overflow-hidden border-t border-border/60 py-20 sm:py-24"
    >
      <div
        aria-hidden
        className="pointer-events-none absolute inset-0 -z-10 opacity-70"
        style={{ background: "var(--gradient-aurora)" }}
      />
      <div aria-hidden className="pointer-events-none absolute inset-0 -z-10 bg-grid opacity-50" />

      <div className="mx-auto max-w-5xl px-6">
        <div className="relative overflow-hidden rounded-3xl border border-border/60 bg-card/70 p-10 text-center shadow-[var(--shadow-soft)] backdrop-blur sm:p-14">
          <div
            aria-hidden
            className="absolute -inset-px -z-10 rounded-3xl bg-gradient-to-tr from-primary/20 via-transparent to-primary/10 opacity-70 blur-2xl"
          />

          <div className="inline-flex items-center gap-2 rounded-full border border-border/60 bg-background/80 px-3 py-1 text-xs text-muted-foreground backdrop-blur">
            <span className="h-1.5 w-1.5 rounded-full bg-primary animate-pulse" />
            {messages.ctaEyebrow}
          </div>

          <h2 className="mt-4 text-3xl font-semibold tracking-tight sm:text-4xl">
            {messages.ctaTitle} <span className="text-gradient">{messages.ctaTitleAccent}</span>
          </h2>
          <p className="mx-auto mt-3 max-w-xl text-base text-muted-foreground">
            {messages.ctaDescription}
          </p>

          <div className="mt-7 flex flex-col items-center justify-center gap-3 sm:flex-row">
            <Button
              asChild
              size="lg"
              className="h-11 rounded-lg px-6 text-sm font-medium animate-glow"
            >
              <a href={contactSales}>
                {messages.contactSales}
                <ArrowRight className="ml-1 h-4 w-4" />
              </a>
            </Button>
            <Button
              asChild
              size="lg"
              variant="outline"
              className="h-11 rounded-lg px-6 text-sm font-medium backdrop-blur"
            >
              <a href={bookDemo}>{messages.bookDemo}</a>
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
}
